import { render, staticRenderFns } from "./MaterialScienceManagement.vue?vue&type=template&id=4a06b616&scoped=true"
import script from "./MaterialScienceManagement.vue?vue&type=script&lang=js"
export * from "./MaterialScienceManagement.vue?vue&type=script&lang=js"
import style0 from "./MaterialScienceManagement.vue?vue&type=style&index=0&id=4a06b616&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a06b616",
  null
  
)

export default component.exports